module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1j5ar"))).then(() => parcelRequire('1iHdE'));